import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { AuditValuePropType, AuditValueSidePropType } from '../../EntityAuditHistory.propTypes';
import AuditFieldValueBoundary from '../AuditFieldValueBoundary';
import AuditRawValue from '../AuditRawValue';

/**
 * One side of a change through the consumer's field renderer. A null value is suppressed (snapshot
 * off for the type), so it keeps the shared "value hidden" placeholder instead of reaching the renderer.
 */
const AuditFieldValue = ({
  renderer: FieldRenderer,
  change,
  side,
  value = null,
  row = null,
  detail = null,
}) => {
  const rawValue = <AuditRawValue value={value} />;

  if (_.isNil(value)) {
    return rawValue;
  }

  return (
    <AuditFieldValueBoundary fallback={rawValue}>
      <FieldRenderer change={change} detail={detail} row={row} side={side} value={value} />
    </AuditFieldValueBoundary>
  );
};

AuditFieldValue.propTypes = {
  renderer: PropTypes.elementType.isRequired,
  change: PropTypes.object.isRequired,
  side: AuditValueSidePropType.isRequired,
  value: AuditValuePropType,
  row: PropTypes.object,
  detail: PropTypes.object,
};

export default AuditFieldValue;
